<section class="admin-page-grid">
  <div class="admin-panel-stack">
    <section class="admin-card">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">{{ pageEyebrow() }}</div>
          <h2>{{ pageTitle() }}</h2>
        </div>
        <button class="secondary-button" type="button" (click)="startCreate()">{{ pageCreateLabel() }}</button>
      </div>

      <div class="admin-stats-grid">
        <article class="admin-stat-card">
          <span>{{ isSuperadminMode() ? 'Admins actifs' : 'Utilisateurs actifs' }}</span>
          <strong>{{ activeCount() }}</strong>
          <small>{{ isSuperadminMode() ? 'Comptes admins en exploitation' : 'Comptes finaux utilisables' }}</small>
        </article>
        <article class="admin-stat-card">
          <span>Invitations</span>
          <strong>{{ pendingCount() }}</strong>
          <small>Activation en attente</small>
        </article>
        <article class="admin-stat-card">
          <span>Licences consommees</span>
          <strong>{{ billableCount() }}</strong>
          <small>Sieges nominativement attribues</small>
        </article>
        <article class="admin-stat-card">
          <span>{{ isSuperadminMode() ? 'Compagnies couvertes' : 'Compagnie scopee' }}</span>
          <strong>{{ isSuperadminMode() ? companyCoverageCount() : 1 }}</strong>
          <small>{{ isSuperadminMode() ? 'Admins repartis sur ces compagnies' : 'Gestion limitee a votre compagnie' }}</small>
        </article>
      </div>
    </section>

    <section class="admin-card admin-compliance-note">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">RGPD</div>
          <h2>Traitement des donnees personnelles</h2>
        </div>
      </div>

      <p class="admin-compliance-copy">
        Cette page contient des donnees nominatives utilisees uniquement pour creer, inviter, administrer et securiser
        les comptes utilisateurs, ainsi que pour attribuer les licences achetees.
      </p>
      <p class="admin-compliance-copy">
        Limitez l acces aux personnes habilitees, ne conservez pas d exports locaux non necessaires, et appliquez les
        regles de suppression ou de mise a jour conformement a la politique de confidentialite.
      </p>

      <div class="admin-compliance-links">
        <a [routerLink]="privacyPolicyUrl">Privacy policy</a>
        <a [routerLink]="termsOfServiceUrl">Terms of service</a>
      </div>
    </section>

    <section class="admin-card" *ngIf="!isSuperadminMode()">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">Inventaire</div>
          <h2>Licences par plan</h2>
        </div>
      </div>

      <div class="admin-license-plan-grid" *ngIf="companyPlanSummaries().length; else noLicenseInventory">
        <article class="admin-license-plan-card" *ngFor="let plan of companyPlanSummaries(); trackBy: trackPlanSummary">
          <div class="admin-license-plan-head">
            <div>
              <div class="admin-table-primary">{{ plan.name }}</div>
              <div class="admin-table-secondary">{{ plan.key }}</div>
            </div>
            <div class="admin-license-plan-count">{{ plan.assigned }}/{{ plan.purchased }}</div>
          </div>

          <div class="admin-license-plan-meta">
            <span>{{ plan.purchased }} achetee(s)</span>
            <span>{{ plan.assigned }} attribuee(s)</span>
            <span>{{ plan.remaining }} restante(s)</span>
          </div>

          <div class="admin-license-list" *ngIf="plan.licenses.length; else noPlanLicenses">
            <div class="admin-license-item" *ngFor="let license of plan.licenses">
              <div>
                <strong>{{ license.id }}</strong>
                <div class="admin-table-secondary">
                  {{ license.status === 'assigned'
                    ? (license.assignedUserName || license.assignedUserEmail || 'Attribuee')
                    : 'Disponible' }}
                </div>
              </div>
              <span class="admin-badge" [ngClass]="license.status">
                {{ license.status === 'assigned' ? 'Attribuee' : 'Libre' }}
              </span>
            </div>
          </div>

          <ng-template #noPlanLicenses>
            <div class="admin-table-secondary">Aucune licence achetee sur ce plan.</div>
          </ng-template>
        </article>
      </div>

      <ng-template #noLicenseInventory>
        <div class="admin-empty-row">Aucune licence achetee pour la compagnie selectionnee.</div>
      </ng-template>
    </section>

    <section class="admin-card">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">Liste</div>
          <h2>Acces et droits</h2>
        </div>
      </div>

      <div class="admin-feedback" *ngIf="feedback()" [ngClass]="feedbackType()">
        {{ feedback() }}
      </div>

      <div class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Utilisateur</th>
              <th *ngIf="canManageCompanies()">Compagnie</th>
              <th>Role</th>
              <th>Plan</th>
              <th>Invitation</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of users(); trackBy: trackUser">
              <td>
                <div class="admin-table-primary">{{ user.firstName }} {{ user.lastName }}</div>
                <div class="admin-table-secondary">{{ user.email }}</div>
                <div class="admin-table-tertiary">{{ user.identifier }}</div>
              </td>
              <td *ngIf="canManageCompanies()">
                <div class="admin-table-primary">{{ user.company }}</div>
              </td>
              <td>
                <div class="admin-table-primary">{{ roleLabel() }}</div>
              </td>
              <td>
                <div class="admin-table-primary">{{ isSuperadminMode() ? 'Aucune licence' : user.productAccessLabel }}</div>
                <div class="admin-table-secondary" *ngIf="!isSuperadminMode()">{{ user.productAccessPlanKey }}</div>
                <div class="admin-table-tertiary" *ngIf="!isSuperadminMode() && resolveAssignedLicenseId(user)">
                  {{ resolveAssignedLicenseId(user) }}
                </div>
                <div class="admin-table-secondary" *ngIf="!isSuperadminMode() && user.consumesSeat && !resolveAssignedLicenseId(user)">
                  Licence consommee
                </div>
                <div class="admin-table-secondary" *ngIf="isSuperadminMode()">Role backoffice uniquement</div>
              </td>
              <td>
                <div class="admin-badge" [ngClass]="user.invitationStatus">
                  {{ user.invitationStatus === 'pending' ? 'Pending' : 'Accepted' }}
                </div>
                <div class="admin-table-tertiary" *ngIf="user.invitationExpiresAt">
                  Exp. {{ user.invitationExpiresAt | date: 'dd/MM/yyyy' : undefined : 'fr' }}
                </div>
              </td>
              <td>
                <div class="admin-actions-cell">
                  <button class="secondary-button" type="button" (click)="editUser(user)">Editer</button>
                  <button class="secondary-button" type="button" (click)="deleteUser(user)" [disabled]="actionUserId() === user.id">
                    Supprimer
                  </button>
                  <button
                    class="secondary-button"
                    type="button"
                    *ngIf="user.invitationStatus === 'pending'"
                    (click)="resendInvitation(user)"
                    [disabled]="actionUserId() === user.id"
                  >
                    Renvoyer
                  </button>
                  <button class="secondary-button" type="button" (click)="sendPasswordReset(user)" [disabled]="actionUserId() === user.id">
                    Reset mdp
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="!users().length">
              <td [attr.colspan]="canManageCompanies() ? 6 : 5" class="admin-empty-row">
                Aucun utilisateur a afficher.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <aside class="admin-card admin-form-card">
    <div class="admin-card-head">
      <div>
        <div class="admin-eyebrow">{{ selectedUserId() ? 'Edition' : 'Creation' }}</div>
        <h2>{{ selectedUserId() ? (isSuperadminMode() ? 'Editer un admin' : 'Editer un utilisateur') : pageCreateLabel() }}</h2>
      </div>
    </div>

    <div class="admin-feedback" *ngIf="formFeedback()" [ngClass]="formFeedbackType()">
      {{ formFeedback() }}
    </div>

    <form class="admin-form" [formGroup]="form" (ngSubmit)="submit()">
      <label class="admin-field">
        <span>Prenom</span>
        <input type="text" formControlName="firstName" placeholder="Jane" />
      </label>

      <label class="admin-field">
        <span>Nom</span>
        <input type="text" formControlName="lastName" placeholder="Doe" />
      </label>

      <label class="admin-field">
        <span>Identifiant</span>
        <input type="text" formControlName="identifier" placeholder="jane.doe" />
      </label>

      <label class="admin-field">
        <span>Email</span>
        <input type="email" formControlName="email" placeholder="jane@company.com" />
      </label>

      <label class="admin-field">
        <span>Compagnie</span>
        <select formControlName="companyId" [disabled]="!canManageCompanies()">
          <option value="">Choisir une compagnie</option>
          <option *ngFor="let company of companies()" [value]="company.id">
            {{ company.name }}
          </option>
        </select>
      </label>

      <label class="admin-field" *ngIf="!isSuperadminMode(); else adminNoLicenseBlock">
        <span>Plan produit</span>
        <select formControlName="assignedPlanKey">
          <option value="">Choisir une licence</option>
          <option
            *ngFor="let option of selectablePlanSummaries(); trackBy: trackPlanSummary"
            [value]="option.key"
            [disabled]="!option.selectable"
          >
            {{ option.optionLabel }}
          </option>
        </select>
      </label>

      <ng-template #adminNoLicenseBlock>
        <div class="admin-readonly-pill">
          Role cree: Company admin. Aucun plan, aucune licence, acces backoffice uniquement.
        </div>
      </ng-template>

      <div class="admin-readonly-pill" *ngIf="!isSuperadminMode()">
        Role cree: User. Une licence de compagnie est obligatoire.
      </div>

      <div class="admin-readonly-pill admin-readonly-pill--accent" *ngIf="!isSuperadminMode() && selectedPlanSummary() as planSummary">
        Plan rattache: {{ planSummary.name }}.
        {{ planSummary.remaining }} restante(s) sur {{ planSummary.purchased }} achetee(s).
        <span *ngIf="planSummary.previewLicenseId">Licence cible: {{ planSummary.previewLicenseId }}.</span>
      </div>

      <label class="admin-checkbox">
        <input type="checkbox" formControlName="sendInvitation" />
        <span>{{ selectedUserId() ? 'Renvoyer une invitation email apres mise a jour' : 'Envoyer une invitation email' }}</span>
      </label>

      <div class="admin-form-actions">
        <button class="primary-button" type="submit" [disabled]="saving()">
          {{ saving() ? 'Sauvegarde...' : selectedUserId() ? 'Mettre a jour' : 'Ajouter' }}
        </button>
        <button class="secondary-button" type="button" (click)="startCreate()">Reinitialiser</button>
      </div>
    </form>
  </aside>
</section>
